// extracted by mini-css-extract-plugin
export default {"normal":"DayleNorm_normal__p6ejQ","AmountOfWater":"DayleNorm_AmountOfWater__mR-D8","text":"DayleNorm_text__WbyL8","section":"DayleNorm_section__qfexe"};